module.exports = __webpack_public_path__ + "assets/to-right.ab7f1d44.svg";